
    import './styles.scoped.css';
    export default {
  "button-group": "awsui_button-group_1v2mg_1s3dt_5",
  "button-group-item": "awsui_button-group-item_1v2mg_1s3dt_9",
  "button-group-tooltip": "awsui_button-group-tooltip_1v2mg_1s3dt_13",
  "item": "awsui_item_1v2mg_1s3dt_17",
  "tooltip": "awsui_tooltip_1v2mg_1s3dt_21"
};
  